module.exports = __webpack_public_path__ + "static/media/troy.106b8e24.png";